import { useSnackbar } from 'notistack';
import { useAudioForm } from './useAudioForm';
import { TEXT_TO_SPEECH_STAGE, UserAudio } from '../../@types';
import { useEffect, useState } from 'react';
import { useAudioTabs } from './useAudioTabs';
import { usePopover } from './usePopover';
import { useAudioPreview } from '../audios';
import { checkValidContent } from '../../utils/utilities';
import { useAudioCredit } from './useAudioCredit';
import { useRouter } from 'next/router';

const getDialogTitle = (currentStage: TEXT_TO_SPEECH_STAGE): string => {
  switch (currentStage) {
    case TEXT_TO_SPEECH_STAGE.PROMPT_INPUT:
      return 'Audio-Voiceover';

    case TEXT_TO_SPEECH_STAGE.CREDITS_CHECK:
      return 'Confirm Audio-Voiceover';

    case TEXT_TO_SPEECH_STAGE.GENERATING:
      return 'Converting Audio-Voiceover';

    default:
      return '';
  }
};

interface Props {
  shouldOpenDialog: boolean;
  handleCloseDialog: () => void;
  refetchTextToSpeechData: () => void;
  voiceOverData: any;
}

export const useTextToSpeech = ({
  shouldOpenDialog,
  handleCloseDialog,
  refetchTextToSpeechData,
  voiceOverData,
}: Props) => {
  const { enqueueSnackbar } = useSnackbar();

  const [currentStage, setCurrentStage] = useState<TEXT_TO_SPEECH_STAGE | null>(
    TEXT_TO_SPEECH_STAGE.CREDITS_CHECK
  );

  const { popoverAnchor, handleOpenPopover, handleClosePopover } = usePopover();

  // const { previewURL, playing, isFetchingAudio, togglePlayPause, handlePausePlayer } =
  //   useAudioPreview({
  //     text: voiceOverData.name,
  //     audioId: voiceOverData.id,
  //   });

  const onDialogClose = () => {
    handleCloseDialog();
    setCurrentStage(null);
  };

  const handleCloseModal = () => {
    handleCloseDialog();
    setCurrentStage(null);
  };

  const {
    textToSpeechId,
    isFetchingAudioCredits,
    errorFetchingCredits,
    isEnoughCredit,
    isSavingAudio,
    availableCredit,
    requiredCredit,
    handleOnSave,
  } = useAudioCredit({
    text: voiceOverData?.text,
    audioId: voiceOverData?.audioId || '',
    name: voiceOverData?.name,
    handleOnSuccess: () => {
      refetchTextToSpeechData();
      setCurrentStage(TEXT_TO_SPEECH_STAGE.GENERATING);
    },
    handleOnCloseDialog: handleCloseDialog,
    shouldFetchCreditDetails: true,
  });

  const { push } = useRouter();
  const handleConfirmOrUpgrade = () => {
    if (isEnoughCredit) {
      handleOnSave();
    } else {
      push('/subscription');
    }
  };
  const handlePreview = () => {
    push(`text-to-audio/${textToSpeechId}`)
  }

  return {
    getDialogTitle,
    enqueueSnackbar,
    currentStage,
    onDialogClose,
    handleCloseModal,
    textToSpeechId,
    isFetchingAudioCredits,
    errorFetchingCredits,
    isEnoughCredit,
    isSavingAudio,
    availableCredit,
    requiredCredit,
    handleOnSave,
    handleConfirmOrUpgrade,
    handlePreview,
  };
};
